import React from "react";
import { BRANDING } from "../config/branding";
import MobilePageFooter from "./MobilePageFooter";
import {
  TRUST_ATTRIBUTION,
  TRUST_CONTACT_EMAIL,
  TRUST_COVERAGE,
} from "./trustContent";
import { getTrustPage } from "./trustRoutes";

/**
 * Standalone trust document (Privacy, Terms, About, Contact).
 */
export default function TrustDocumentPage({ pageId, onBack, onNavigate }) {
  const page = getTrustPage(pageId);
  if (!page) return null;

  const isContact = pageId === "contact";

  return (
    <div className="v2-trust-page">
      <header className="v2-trust-page-header">
        <button type="button" className="v2-trust-back" onClick={onBack}>
          ← Back to map
        </button>
        <div className="v2-trust-brand">
          <img className="v2-logo" src={BRANDING.logoSrc} alt="" />
          <span className="v2-trust-brand-name">{BRANDING.appName}</span>
        </div>
      </header>

      <main className="v2-trust-page-main">
        <h1 className="v2-trust-title">{page.title}</h1>

        {page.sections.map((section, i) => (
          <section key={i} className="v2-trust-section">
            {section.heading ? (
              <h2 className="v2-trust-heading">{section.heading}</h2>
            ) : null}
            {section.paragraphs.map((p, j) => (
              <p key={j} className="v2-trust-para">
                {p}
              </p>
            ))}
          </section>
        ))}

        {isContact ? (
          <p className="v2-trust-actions">
            <a
              className="v2-trust-email-btn"
              href={`mailto:${TRUST_CONTACT_EMAIL}`}
            >
              Email {TRUST_CONTACT_EMAIL}
            </a>
          </p>
        ) : null}

        {pageId === "about" ? (
          <section className="v2-trust-section">
            <h2 className="v2-trust-heading">Coverage</h2>
            <p className="v2-trust-para">{TRUST_COVERAGE.summary}</p>
            <h2 className="v2-trust-heading">Sources</h2>
            <ul className="v2-trust-attr-list">
              {TRUST_ATTRIBUTION.items.map((item) => (
                <li key={item.label}>
                  <a href={item.href} target="_blank" rel="noreferrer noopener">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="v2-trust-para v2-trust-para--muted">
              Full notice also under{" "}
              <button
                type="button"
                className="v2-trust-inline-link"
                onClick={() => onNavigate?.("privacy")}
              >
                Privacy
              </button>{" "}
              and{" "}
              <button
                type="button"
                className="v2-trust-inline-link"
                onClick={() => onNavigate?.("terms")}
              >
                Terms
              </button>
              .
            </p>
          </section>
        ) : null}
      </main>
      <MobilePageFooter onNavigate={onNavigate} />
    </div>
  );
}
